import React from 'react';
import PropTypes from 'prop-types';
import ComponentLoader from './ComponentLoader/ComponentLoader';

/**
 * FolderWrapper Component Loader (dibs-portfolio-folder)
 */
const importFunc = () => {
    return import(/* webpackChunkName: "FolderWrapper" */
    'dibs-portfolio-folder').then(({ FolderWrapper }) => FolderWrapper);
};

export function FolderWrapperLoader(props) {
    return (
        <ComponentLoader
            {...props}
            load={props.load}
            importFunc={importFunc}
            useLoadingComponent={false}
        />
    );
}

FolderWrapperLoader.propTypes = {
    load: PropTypes.bool.isRequired,
};

export default FolderWrapperLoader;
